import { Reducer, combineReducers } from 'redux'
import { RouterState, connectRouter } from 'connected-react-router'
import actionLogs, { ActionLogsState } from './actionLogs'
import { History, LocationState } from 'history'

import app from './app'
import configs from './config'
import content from './content'
import contentPush from './contentPush'
import countries from './countries'
import chains from './chains'
import customMessages from './customMessages'
import dashboards from './dashboards'
import device from './device'
import notifications from './notifications'
import promos, { PromosState } from './promos'
import variants, { VariantsState } from './variants'
import credits, { CreditsState } from './credits'
import ticketSizes, { TicketSizesState } from './ticketSizes'
import purgatory, { PurgatoryState } from './purgatory'
import socket from './socket'
import statistics from './statistics'
import stores from './stores'
import user from './user'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

export type RootState = {
  router: RouterState,
  actionLogs: ActionLogsState,
  app: ReturnType<typeof app>,
  configs: ReturnType<typeof configs>,
  content: ReturnType<typeof content>,
  contentPush: ReturnType<typeof contentPush>,
  countries: ReturnType<typeof countries>,
  chains: ReturnType<typeof chains>,
  customMessages: ReturnType<typeof customMessages>,
  dashboards: ReturnType<typeof dashboards>,
  device: ReturnType<typeof device>,
  notifications: ReturnType<typeof notifications>,
  promos: PromosState,
  variants: VariantsState,
  credits: CreditsState,
  ticketSizes: TicketSizesState,
  purgatory: PurgatoryState,
  socket: ReturnType<typeof socket>,
  statistics: ReturnType<typeof statistics>,
  stores: ReturnType<typeof stores>,
  user: ReturnType<typeof user>,
};

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default function createRootReducer(history: History): Reducer {
  return combineReducers({
    router: connectRouter<LocationState>(history),
    actionLogs,
    app,
    configs,
    content,
    contentPush,
    countries,
    chains,
    customMessages,
    dashboards,
    device,
    notifications,
    promos,
    variants,
    credits,
    ticketSizes,
    purgatory,
    socket,
    statistics,
    stores,
    user,
  });
}
